import { CartSkuOption } from '../types';

export default function skuIsOverQuantityLimit(sku: CartSkuOption, quantity: number): boolean {
    return sku.maxQuantityAllowedPerOrder > 0 && quantity > sku.maxQuantityAllowedPerOrder;
}
